import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase.js";  // ✅ Ensure Firestore is imported correctly

const Stadiums = () => {
  const [stadiums, setStadiums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStadiums = async () => {
      try {
        const stadiumsCollection = collection(db, "stadiums");
        const querySnapshot = await getDocs(stadiumsCollection);

        const stadiumList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setStadiums(stadiumList);
      } catch (error) {
        console.error("❌ Error fetching stadiums:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStadiums();
  }, []);

  return (
    <div className="p-10">
      <h1 className="text-3xl font-bold text-blue-600">Explore Stadiums</h1>

      {loading ? (
        <p className="text-gray-500">Loading stadiums...</p>
      ) : stadiums.length === 0 ? (
        <p className="text-gray-500">⚠️ No stadiums found. Check Firestore data.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          {stadiums.map((stadium) => (
            <div key={stadium.id} className="bg-white shadow-lg rounded-lg overflow-hidden">
              <img src={stadium.image} alt={stadium.name} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="text-xl font-bold">{stadium.name}</h3>
                <p className="text-gray-600">{stadium.city}</p>
                <p className="text-gray-500">{stadium.team}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ❌ Remove `module.exports = Stadiums;`
// ✅ Replace it with ES6 syntax:
export default Stadiums;
